<template>
    <div class="key-data-qualification-basic-info">
        <div class="content">
            <el-row>
                <el-col class="has-bg right-text" :span="2">供应商编码</el-col>
                <el-col :span="4">{{ formData.supplierCode }}</el-col>
                <el-col class="has-bg right-text" :span="2">供应商名称</el-col>
                <el-col :span="4">{{ formData.supplierName }}</el-col>
                <el-col class="has-bg right-text" :span="2"><span class="required">*</span>联系电话</el-col>
                <el-col :span="4">
                    <span v-if="pdfTransforming">{{ formData.phone }}</span>
                    <el-input v-else :class="errorItems.phone ? 'is-error' : ''" v-model.trim="formData.phone" />
                </el-col>
                <el-col class="has-bg right-text" :span="2"><span class="required">*</span>身份证</el-col>
                <el-col :span="4">
                    <span v-if="pdfTransforming">{{ formData.idCard }}</span>
                    <el-input v-else :class="errorItems.idCard ? 'is-error' : ''" v-model.trim="formData.idCard" />
                </el-col>
            </el-row>
            <el-row>
                <el-col class="has-bg right-text" :span="2"><span class="required">*</span>紧急联系人</el-col>
                <el-col :span="4">
                    <span v-if="pdfTransforming">{{ formData.contacts }}</span>
                    <el-input v-else :class="errorItems.contacts ? 'is-error' : ''" v-model.trim="formData.contacts" />
                </el-col>
                <el-col class="has-bg right-text" :span="2"><span class="required">*</span>紧急联系人电话</el-col>
                <el-col :span="4">
                    <span v-if="pdfTransforming">{{ formData.contactsMobile }}</span>
                    <el-input v-else :class="errorItems.contactsMobile ? 'is-error' : ''" v-model.trim="formData.contactsMobile" />
                </el-col>
                <el-col class="has-bg right-text" :span="2"><span class="required">*</span>与供应商关系</el-col>
                <el-col :span="4">
                    <span v-if="pdfTransforming">{{ formData.supplierRelation }}</span>
                    <el-input v-else :class="errorItems.supplierRelation ? 'is-error' : ''" v-model.trim="formData.supplierRelation" />
                </el-col>
                <el-col class="has-bg right-text" :span="2"></el-col>
                <el-col :span="4"></el-col>
            </el-row>
            <el-row>
                <el-col class="has-bg right-text" :span="2"><span class="required">*</span>家庭住址</el-col>
                <el-col :span="10">
                    <span v-if="pdfTransforming">{{ formData.address }}</span>
                    <el-input v-else :class="errorItems.address ? 'is-error' : ''" v-model.trim="formData.address" />
                </el-col>
                <el-col class="has-bg right-text" :span="2"><span class="required">*</span>车牌号码</el-col>
                <el-col :span="4">
                    <span v-if="pdfTransforming">{{ formData.licensePlateNo }}</span>
                    <el-input v-else :class="errorItems.licensePlateNo ? 'is-error' : ''" v-model.trim="formData.licensePlateNo" />
                </el-col>
                <el-col class="has-bg right-text" :span="2"><span class="required">*</span>车型</el-col>
                <el-col :span="4">
                    <span v-if="pdfTransforming">{{ formData.carType }}</span>
                    <SrmAdvance
                        v-else
                        :class="errorItems.carType ? 'is-error' : ''"
                        :mValue="formData.carType"
                        :params="carTypeConfig"
                        @getAdvanceValue="getAdvanceValue($event)"
                    />
                </el-col>
            </el-row>
        </div>
    </div>
</template>

<script>
import dayjs from 'dayjs'
import SrmAdvance from '../../../../../../components/srmAdvance/index.vue';

const INIT_FORM = {
    supplierCode: '',
    supplierName: '',
    phone: '',
    idCard: '',
    contacts: '',
    contactsMobile: '',
    supplierRelation: '',
    address: '',
    licensePlateNo: '',
    carType: '',
}

export default {
    components: { SrmAdvance },
    props: {
        pdfTransforming: {
            type: Boolean,
            default: false
        }
    },
    data() {
        return {
            formData: {
                ...INIT_FORM
            },
            carTypeConfig: {
                name: '车型',
                value: 'carType',
                advanceConfig: [
                    { prop: 'actualVechile', value: '车型' },
                    { prop: 'cdegCode', value: '车型编码' },
                ],
                prefix: '/api-srm-web',
                tableConfig: [
                    { prop: 'actualVechile', value: '车型' },
                    { prop: 'cdegCode', value: '车型编码' },
                ],
                advanceUrl: '/supplier/dcApi/cdTsEquipmentGroupSearch',
                cbParams: ['actualVechile#carType'],
            },
        };
    },
    computed: {
        errorItems() {
            const items = {
                phone: false,
                idCard: false,
                contacts: false,
                contactsMobile: false,
                supplierRelation: false,
                address: false,
                licensePlateNo: false,
                carType: false,
            }
            Object.keys(items).forEach(key => {
                const maxLength = key === 'address' ? 100 : 20
                // if (key === 'carType') {
                //     items[key] = ['', null, undefined].includes(this.formData[key])
                // } else {
                //     items[key] = ['', null, undefined].includes(this.formData[key]) || this.formData[key].length > 20
                // }
                items[key] = ['', null, undefined].includes(this.formData[key]) || this.formData[key].length > maxLength
            })
            return items
        },
    },
    methods: {
        setBaseInfo(data) {
            this.formData.supplierCode = data.supplierCode ||  ''
            this.formData.supplierName = data.supplierName ||  ''
            this.formData.idCard = data.idCard ||  ''
            this.formData.contacts = data.contacts ||  ''
            this.formData.contactsMobile = data.contactsMobile ||  ''
        },
        setFormData(data) {
            this.formData.phone = data.phone || ''
            this.formData.supplierRelation = data.supplierRelation || ''
            this.formData.address = data.address || ''
            this.formData.licensePlateNo = data.licensePlateNo || ''
            this.formData.carType = data.carType || ''
            if (data.idCard) {
                this.formData.idCard = data.idCard
            }
            if (data.contacts) {
                this.formData.contacts = data.contacts
            }
            if (data.contactsMobile) {
                this.formData.contactsMobile = data.contactsMobile
            }
        },
        getData() {
            const isError = Object.entries(this.errorItems).some(item => item[1])
            if (isError) {
                return false
            } else {
                return { ...this.formData }
            }
        },
        reset() {
            this.formData = { ...INIT_FORM }
        },
        timeformat(time) {
            return time ? dayjs(time).format('YYYY-MM-DD') : ''
        },
        getAdvanceValue(val) {
            this.formData.carType = val.carType
        },
    },
    mounted() {
        
    },
};
</script>

<style lang="less" scoped>
.key-data-qualification-basic-info {
    margin-bottom: 20px;
    font-size: 14px;
    color: #000;

    .sub-title {
        display: inline-block;
        margin-bottom: 10px;
        font-size: 16px;
        font-weight: bold;

        &::before {
            display: inline-block;
            margin-right: 5px;
            width: 5px;
            height: 14px;
            background: #409EFF;
            content: '';
            vertical-align: middle;
        }
    }

    .title-container {
        margin-bottom: 10px;
    }

    .content {
        border-top: 1px solid #ddd;
        border-left: 1px solid #ddd;
    }

    .has-bg {
        display: flex;
        align-items: center;
        background: #f5f7fa;
    }

    .right-text {
        padding-right: 10px;
        text-align: right;
    }

    .el-row {
        display: flex;
        width: 100%;
    }

    .el-col {
        display: flex;
        align-items: center;
        float: none;
        padding: 8px;
        min-height: 40px;
        border-right: 1px solid #ddd;
        border-bottom: 1px solid #ddd;
    }

    .el-input, .el-select {
        width: 100%;
    }

    .is-error {
        .el-input__inner, .el-select .el-input__inner {
            border-color: #f56c6c;
        }
    }

    .required {
        margin-right: 4px;
        color: #f56c6c;
    }
}
</style>